export default __webpack_public_path__ + "static/media/E-V.c15caeaa.mp4";